import { render, staticRenderFns } from "./denomination-select.vue?vue&type=template&id=77f34478&scoped=true"
import script from "./denomination-select.vue?vue&type=script&lang=js"
export * from "./denomination-select.vue?vue&type=script&lang=js"
import style0 from "./denomination-select.vue?vue&type=style&index=0&id=77f34478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f34478",
  null
  
)

export default component.exports